import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=a0a50c1c&scoped=true&"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=a0a50c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a50c1c",
  null
  
)

export default component.exports